/*
 * @Author: your name
 * @Date: 2019-11-21 18:30:52
 * @LastEditTime: 2020-04-04 20:45:03
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mei_qi_zeroweb_endlyq/src/router/store/index.js
 */
// 店铺
const storeChoose = () => import(/* webpackChunkName: 'storeChoose' */ '@views/store/choose/index')
const storeCreate = () => import(/* webpackChunkName: 'storeCreate' */ '@views/store/create/index')
const storeRegister = () =>
  import(/* webpackChunkName: 'storeRegister' */ '@views/store/register/index')
const storeProtocol = () =>
  import(/* webpackChunkName: 'storeProtocol' */ '@views/store/protocol/index')
const storeMe = () => import(/* webpackChunkName: 'storeProtocol' */ '@views/store/me/index')

const routes = [
  {
    path: '/store/choose',
    component: storeChoose,
    name: 'storeChoose',
    meta: { title: '', first: false, resourceCode: '' }
  },
  {
    path: '/store/me',
    component: storeMe,
    name: 'storeMe',
    meta: { title: '', first: false, resourceCode: '' }
  },
  {
    path: '/store/create',
    component: storeCreate,
    name: 'storeCreate',
    meta: { title: '', first: false, resourceCode: '' }
  },
  {
    path: '/store/register',
    component: storeRegister,
    name: 'storeRegister',
    meta: { title: '', first: false, resourceCode: '' }
  },
  {
    path: '/protocol',
    component: storeProtocol,
    name: 'storeProtocol',
    meta: { title: '', first: false, resourceCode: '' }
  }
]
export default {
  routes
}



// WEBPACK FOOTER //
// ./src/router/store/index.js